<section class="container">
  <div class="header-wrapper">
    <h1>Applications</h1>
  </div>
  <div class="content-wrapper">
    <button [disabled]="isReadOnly" mat-raised-button (click)="editingApplication={}" color="accent">New Application</button>
    <table>
      <thead>
        <tr>
          <th>Description</th>
          <th>Redirect URL</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        @for (app of applications; track app) {
          <tr>
            <td>{{app.description}}</td>
            <td>{{app.redirectUri}}</td>
            <td>
              <button mat-raised-button color="accent" (click)="edit(app)">Edit</button>
              <button mat-raised-button color="warn" (click)="delete(app)">Delete</button>
            </td>
          </tr>
        }
      </tbody>
    </table>

    @if (editingApplication) {
      <div>
        <h3>Edit</h3>
        <form #settingsForm="ngForm" (ngSubmit)="onSubmit(editingApplication, settingsForm)">
          <div>
            <mat-form-field appearance="fill">
              <mat-label>Application ID</mat-label>
              <input name="id" matInput disabled [(ngModel)]="editingApplication.applicationId" />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field appearance="fill">
              <mat-label>Description</mat-label>
              <input name="desc" matInput required [(ngModel)]="editingApplication.description" />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field appearance="fill">
              <mat-label>Redirect URL</mat-label>
              <input name="redirect" matInput required [(ngModel)]="editingApplication.redirectUri" />
            </mat-form-field>
          </div>
          <button mat-raised-button type="submit" color="accent">Save</button>
          <a mat-button color="warn" (click)="editingApplication=null">Cancel</a>
        </form>
      </div>
    }
  </div>
</section>